import WithSubnavigation from './navigation'; // Ensures the desktop navigation is imported
import { useState } from 'react'; // Manages the state of the modal (open/close)
import { Link, useLocation } from 'react-router-dom'; // Use react-router-dom for navigation and location
import './custom.css'; // Custom styles

interface HeaderProps {
  modalOpened: boolean;
}

const Header: React.FC<HeaderProps> = ({ modalOpened }) => {
  const [isOpen, setIsOpen] = useState(false); // State to manage the modal open/close
  const location = useLocation(); // Use useLocation to get the current path

  const toggleMenu = () => setIsOpen(!isOpen); // Toggles the state of the modal

  return (
    <header className="site-header w-screen fixed z-30 w-full">
      <nav className='hidden md:block'>
        <WithSubnavigation darkmode={location.pathname === '/' ? true : false} /> {/* Passes dark mode setting */}
        <a tabIndex={0} aria-label="Home" className="star-1 fixed mix-blend-difference z-[31]" href="/">
          <figure className="star-icon w-[var(--star-size)] h-[var(--star-size)] relative">
            <svg width="28" height="26" viewBox="0 0 28 26" className="w-full h-auto max-h-full" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.0003 0L17.1435 9.67376H27.3151L19.0861 15.6525L22.2293 25.3262L14.0003 19.3475L5.77135 25.3262L8.91454 15.6525L0.685547 9.67376H10.8571L14.0003 0Z" fill="white"></path></svg>
          </figure>
        </a>
      </nav>

      {/* Mobile Navigation - Hamburger Menu */}
      <div
        aria-label="Menu"
        onClick={toggleMenu}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggleMenu();
          }
        }}
        tabIndex={0}
        className="menu-icon flex md:hidden fixed z-[36] top-0 right-0 px-4 py-2 justify-center items-center"
      >
        <div className="flex flex-col justify-between h-[10px] pb-[20px] pt-[8px] px-[10px] box-content uppercase cursor-pointer">
          { isOpen ? 'Close' : 'Menu' }
        </div>

        <a tabIndex={0} aria-label="Home" className="md:hidden star-1 fixed mix-blend-difference z-[31]" href="/">
          <figure className="star-icon w-[var(--star-size)] h-[var(--star-size)] relative">
              <svg width="28" height="26" viewBox="0 0 28 26" className="w-full h-auto max-h-full" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.0003 0L17.1435 9.67376H27.3151L19.0861 15.6525L22.2293 25.3262L14.0003 19.3475L5.77135 25.3262L8.91454 15.6525L0.685547 9.67376H10.8571L14.0003 0Z" fill="white"></path></svg>
            </figure>
          </a>
      </div>


      {/* Modal that appears when the hamburger is clicked */}
      <div className={`site-header-mobile md:hidden text-white fixed z-[35] top-0 w-screen flex justify-end ${isOpen && "site-header-mobile-open"}`}>
        <div onClick={() => toggleMenu()} className={`mobile-drawer fixed inset-0 h-dvh flex flex-col justify-between bg-black z-80 transition duration-500 ease-[cubic-bezier(0.32,0.72,0,1)] ${isOpen ? "mobile-nav-open" : "mobile-nav-closed"}`}>
          <nav className="flex flex-col justify-between h-full">
            {/* <ul className="nav-list pt-32 p-4 flex flex-col justify-center items-center gap-4 text-xl"> */}

            {/* Main navigation links centered */}
            <div className='nav-list pt-32 p-4 flex flex-col justify-center items-center gap-4 text-xl'>
              <Link className="nav-item uppercase p-4" to="https://beyonce.com">
                HOME
              </Link>
              <Link className="nav-item uppercase p-4" to="https://beyonce.com/tour">
                TOUR
              </Link>
              <Link className="nav-item uppercase p-4" to="https://shop.beyonce.com">
                SHOP
              </Link>

              <Link className="nav-item uppercase p-4" to="https://parfum.beyonce.com">
                PARFUM
              </Link>
              <Link className="nav-item uppercase p-4" to="https://cecred.com">
                CÉCRED
              </Link>
              <Link className="nav-item uppercase p-4" to="https://www.sirdavis.com/?utm_source=msb&utm_medium=community&utm_campaign=SIRDAVIS_WS_USA_SIRDAVISBRLAUNCH_WHI_MASTERBRAND_SIRDAVIS_AW">
                SIRDAVIS
              </Link>
            </div>

            {/* Footer navigation moved to modal, centered in a single line */}
            <footer className="text-xs w-full">
              <div className="flex justify-center gap-6 px-4 py-6 text-center whitespace-nowrap">
                <Link className="nav-item uppercase" to="https://beyonce.attn.tv/p/Q9J/landing-page">
                  JOIN
                </Link>
                <Link className="nav-item uppercase" to="https://beencountry.com">
                  BEEN COUNTRY
                </Link>
                <Link className="nav-item uppercase" to="https://beyonce.com/terms-conditions">
                  TERMS
                </Link>
                <Link className="nav-item uppercase" to="https://beyonce.com/privacy-policy">
                  PRIVACY
                </Link>
              </div>
            </footer>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;